import React, { Fragment, useState } from "react";
import { Col, Card, CardHeader, CardBody, Form, FormGroup, Label, Row } from 'reactstrap';
import { Btn, H3, Breadcrumbs } from "../../../AbstractElements";
import { useForm, Controller } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { AreaCodeError, AreaNameError, Coupon, CouponAdd, CouponCode, CouponName, CustomerLogin, DiscountT, EndDate, minumumAmount, Save, ShippingFree, StartDate, Total, Type, UserPerCoupon, UserPerCustomer } from "../../../Constant";
import { addCoupon, addCouponRole } from "../../../CommonUrl";
import { useSelector } from "react-redux";
import { postClientUrlWithToken } from "../../../Utils/restUtils";
import { toast } from 'react-toastify';
import Transparentspinner from "../../Common/Loader/Transparentspinner";
import Typeahead from "../../../CommonElements/TypeAhead";
import DatePicker from 'react-datepicker';
import moment from "moment";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const couponSchema = Yup.object().shape({
    couponName: Yup.string()
        .required("Coupon Name is required"),

    couponCode: Yup.string()
        // .matches(/^[A-Z0-9]+$/, "Coupon Code must be uppercase letters/numbers only")
        .required("Coupon Code is required"),

    type: Yup.mixed()
        .required("Type is required"),

    discount: Yup.number()
        .typeError("Discount must be a number")
        .positive("Discount must be greater than 0")
        .required("Discount is required"),

    total: Yup.number()
        .typeError("Minimum amount must be a number")
        .min(1, "Minimum amount must be at least 1")
        .required("Minimum amount is required"),

    date: Yup.date()
        .required("Start Date is required"),

    enddate: Yup.date()
        .min(Yup.ref("date"), "End Date must be after Start Date")
        .required("End Date is required"),

    userPerCoupon: Yup.number()
        .typeError("User per coupon must be a number")
        .min(1, "At least 1 user per coupon")
        .required("User per coupon is required"),

    userPerCustomer: Yup.number()
        .typeError("User per customer must be a number")
        .min(1, "At least 1 user per customer")
        .required("User per customer is required"),

    shippingFree: Yup.string()
        .oneOf(["yes", "no"], "Invalid selection")
        .required("Shipping Free selection is required"),

    customerLogin: Yup.string()
        .oneOf(["yes", "no"], "Invalid selection")
        .required("Customer Login selection is required"),
});


const CouponForm = () => {
    const { register, handleSubmit, control, formState: { errors } } = useForm({
        resolver: yupResolver(couponSchema),
        defaultValues:{
            date:new Date(),
            enddate:new Date()
        }
    });
    const authState = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const navigate = useNavigate();
    const options = [
        { value: 'cash', label: 'Cash' },
        { value: 'percentage', label: 'Percentage' },
    ];

    const handleChangeDate = date => {
        setStartDate(date);
    };

    const handleChangeEndDate = date => {
        setEndDate(date);
    };

    const onSubmit = async (data) => {
        const payload = {
            ...data,
            startDate,
            endDate,
        };
        setLoading(true);
        const postRequest = {
            name: payload.couponName, code: payload.couponCode, type: payload.type?.value, discount: payload.discount,
            start_date: moment(payload.date).format('YY/MM/DD'), end_date: moment(payload?.enddate).format('YY/MM/DD'),
            min_amount: payload.total, free_shipping: payload.shippingFree, customer_login: payload.customerLogin,
            use_per_customer: payload.userPerCustomer, use_per_coupon: payload.userPerCoupon,
        }
        const addAreaResponse = await postClientUrlWithToken(authState.apiUrl, authState.userRole === 1 ? addCoupon : addCouponRole, postRequest);
        if (addAreaResponse.status === 200) {
            if (addAreaResponse.data.status === true) {
                toast.success(addAreaResponse.data.message)
                navigate(`${process.env.PUBLIC_URL}/settings/coupon`);
            } else {
                toast.error(addAreaResponse.data.message)
                setLoading(false);
            }
        } else if (addAreaResponse.status >= 400 && addAreaResponse.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (addAreaResponse.status >= 500 && addAreaResponse.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
        setLoading(false);
    };
    return (
        <Fragment>
            {loading && (
                <Transparentspinner />
            )}
            <Breadcrumbs mainTitle={Coupon} parent="Settings" title={Coupon} />
            <Card>
                <CardHeader className="pb-0">
                    <H3>{CouponAdd}</H3>
                </CardHeader>
                <CardBody>
                    <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                        <Row className="g-3 pt-3">
                            <Col md='6'>
                                <Label className="form-label" for="area-name">{CouponName}<span className="requireStar">*</span></Label>
                                <input className="form-control" id="area-name" type="text" {...register('couponName', { required: true })} />
                                <span className="text-danger">{errors.couponName?.message}</span>
                            </Col>
                            <Col md="6">
                                <Label className="form-label" for="area_code">{CouponCode} <span className="requireStar">*</span></Label>
                                <input className="form-control" id="area_code" type="text" {...register('couponCode', { required: true })} />
                                <span className="text-danger">{errors.couponCode?.message}</span>
                            </Col>
                        </Row>
                        <Row className="g-3 pt-3">
                            <Col md="6">
                                <Label className="form-label" >{Type} <span className="requireStar">*</span></Label>
                                <Controller
                                    name="type"
                                    control={control}
                                    render={({ field }) => (
                                        <Typeahead
                                            options={options}
                                            onChange={(value) => {
                                                field.onChange(value);
                                            }}
                                            value={field.value}
                                        />
                                    )}
                                />
                                <p className="text-danger">{errors.type?.message}</p>
                            </Col>
                            <Col md="6">
                                <Label className="form-label" for="area_code">{DiscountT} <span className="requireStar">*</span></Label>
                                <input className="form-control" id="area_code" type="text" {...register('discount', { required: true })} />
                                <span className="text-danger">{errors.discount?.message}</span>

                            </Col>
                        </Row>
                        <Row className="g-3 pt-3">
                            <Col md='6'>
                                <Label className="form-label" for="area-name">{minumumAmount}<span className="requireStar">*</span></Label>
                                <input className="form-control" id="area-name" type="text" {...register('total', { required: true })} />
                                <span className="text-danger">{errors.total?.message}</span>

                            </Col>
                            <Col md="3">
                                <FormGroup className="mb-3">
                                    <Label className="form-label" for="date">{StartDate} <span className="requireStar">*</span></Label>
                                    <Col xl='12' md="12" sm='12'>
                                        <Controller
                                            name="date"
                                            control={control}
                                            render={({ field }) => (
                                                <DatePicker
                                                    id="date"
                                                    style={{ padding: '12px 100px' }}
                                                    className="form-control "
                                                    dateFormat="dd/MM/yyyy"
                                                    placeholderText="dd/mm/yyyy"
                                                    // peekNextMonth
                                                    selected={field.value}   // <-- bind value
                                                    showMonthDropdown
                                                    onChange={(date) => field.onChange(date)}  // <-- update RHF state

                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    required
                                                />
                                            )} />
                                        <p className="text-danger">{errors.date?.message}</p>
                                    </Col>
                                </FormGroup>
                            </Col>
                            <Col md="3">
                                <FormGroup className="mb-3">
                                    <Label className="form-label" for="enddate">{EndDate} <span className="requireStar">*</span></Label>
                                    <Col xl='12' md="12" sm='12'>
                                        <Controller
                                            name="enddate"
                                            control={control}
                                            render={({ field }) => (
                                                <DatePicker
                                                    id="enddate"
                                                    style={{ padding: "12px 100px" }}
                                                    className="form-control"
                                                    dateFormat="dd/MM/yyyy"
                                                    placeholderText="dd/mm/yyyy"
                                                    selected={field.value}   // <-- bind value
                                                    onChange={(date) => field.onChange(date)}  // <-- update RHF state
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                />
                                            )} />
                                        <p className="text-danger">{errors.enddate?.message}</p>

                                    </Col>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row className="g-3 pt-3">
                            <Col md='6'>
                                <Label className="form-label" for="area-name">{UserPerCoupon}<span className="requireStar">*</span></Label>
                                <input className="form-control" id="area-name" type="text" {...register('userPerCoupon', { required: true })} />
                                <span className="text-danger">{errors.userPerCoupon?.message}</span>
                            </Col>
                            <Col md='6'>
                                <Label className="form-label" for="area-name">{UserPerCustomer}<span className="requireStar">*</span></Label>
                                <input className="form-control" id="area-name" type="text" {...register('userPerCustomer', { required: true })} />
                                <span className="text-danger">{errors.userPerCustomer?.message}</span>
                            </Col>
                        </Row>
                        <Row className="g-3 pt-3">
                            <Col md="6">
                                <FormGroup className="mb-3">
                                    <Label>{ShippingFree} <span className="requireStar">*</span></Label>
                                    <Col xl='12' md="12" sm='12'>
                                        <label htmlFor="field-yes" style={{ marginRight: '30px' }}>
                                            <input
                                                {...register("shippingFree")}
                                                type="radio"
                                                className="radio_animated"
                                                value="yes"
                                                id="field-yes"
                                            />
                                            Yes
                                        </label>
                                        <label htmlFor="field-no">
                                            <input
                                                {...register("shippingFree")}
                                                type="radio"
                                                className="radio_animated"
                                                value="no"
                                                id="field-no"
                                            />
                                            No
                                        </label>
                                        <p className="text-danger">{errors.shippingFree?.message}</p>
                                    </Col>
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup className="mb-3">
                                    <Label>{CustomerLogin} <span className="requireStar">*</span></Label>
                                    <Col xl='12' md="12" sm='12'>
                                        <label htmlFor="field-yes" style={{ marginRight: '30px' }}>
                                            <input
                                                {...register("customerLogin")}
                                                type="radio"
                                                className="radio_animated"
                                                value="yes"
                                                id="field-yes"
                                            />
                                            Yes
                                        </label>
                                        <label htmlFor="field-no">
                                            <input
                                                {...register("customerLogin")}
                                                type="radio"
                                                className="radio_animated"
                                                value="no"
                                                id="field-no"
                                            />
                                            No
                                        </label>
                                        <p className="text-danger">{errors.customerLogin?.message}</p>

                                        {/* {errors.customerLogin && <span className="text-danger">Login option is required</span>} */}
                                    </Col>
                                </FormGroup>

                            </Col>
                        </Row>
                        <FormGroup>
                        </FormGroup>
                        <Btn attrBtn={{ color: "primary" }} type="submit">{Save}</Btn>
                    </Form>
                </CardBody>
            </Card>
        </Fragment>
    )
}
export default CouponForm;